export const personRootPages = [
  {
    path: '/person',
    children: [
      {
        path: ':personId',
        component: () => import('@/views/contact/TheContactViewPage.vue'),
        name: 'person_view_route',
        props: (route) => {
          return {
            type: 'person',
            ...route.params
          }
        }
      }
    ]
  }
]
